export const  gasProperties= [
    {id: 1, title: 'وضعیت', value: 'status'},
    {id: 3, title: 'نوع مصرف', value: 'UseType'},
    {id: 5, title: 'آدرس', value: 'City'},
    {id: 6, title: 'تعداد واحد', value: 'UnitCount'},
    {id: 4, title: 'گروه', value: 'Group'},
    {id: 11, title: 'ظرفیت', value: 'Capacity'},
    {id: 8, title: 'شماره اشتراک', value: 'SubscriptionNumber',noComma:true},
    {id: 12, title: 'سریال کنتور', value: 'MeterSerial',noComma:true},
    {id: 13, title: 'رقم کنتور فعلی', value: 'CurrentCounterDigit',noComma:true},
    {id: 9, title: 'رقم کنتور پیشین', value: 'PreviousCounterDigit',noComma:true},
    {id: 10, title: 'کارکرد کنتور', value: 'CounterActivity',noComma:true},
    {id: 11, title: 'تاریخ قرائت', value: 'CurrentReadingDate',noComma:true},
    {id: 11, title: 'تاریخ قرائت پیشین', value: 'PreviousReadingDate',noComma:true},
    {id: 11, title: 'بهای گاز مصرفی', value: 'GasConsumptionAmount'},
    {id: 11, title: 'مصرف استاندارد', value: 'StandardConsumption'},
    {id: 11, title: 'آبونمان', value: 'Subscription'},
    {id: 11, title: 'عوارض', value: 'Taxes'},
    {id: 11, title: 'بیمه', value: 'Insurance'},
    {id: 11, title: 'بدهی متفرقه', value: 'OtherDebt'},
    {id: 11, title: 'مانده بدهی', value: 'RemainingDebt'},
    {id: 11, title: 'مانده صورتحساب قبلی', value: 'RemainingPreviousInvoice'},
    {id: 11, title: 'تعداد بدهی', value: 'DebtCount'},
    {id: 11, title: 'عوارض گازرسانی به روستا', value: 'VillageGasTaxes'},
    {id: 11, title: 'مانده مبلغ هزار ریال', value: 'RemainingAmount1000Rial'},
    {id: 11, title: 'کسر مبلغ هزار ریال', value: 'DeductionAmount1000Rial'},
    {id: 11, title: 'شماره سری', value: 'SerialNumber'},
    {id: 11, title: 'کد آدرس', value: 'AddressCode',noComma:true},
    {id: 11, title: 'شماره پرونده', value: 'FileNumber',noComma:true},
  
  ];

  export const electricityProperties = [
    {id: 0, title: 'شرکت توزیع', value: 'CompanyName'},
    {id: 1, title: 'وضعیت', value: 'status'},
    {id: 3, title: 'نوع مشترک', value: 'CustomerType'},
    {id: 4, title: 'نوع تعرفه', value: 'TariffType'},
    {id: 5, title: 'آدرس', value: 'Address'},
    {id: 6, title: 'شماره کنتور', value: 'IdentificationNumber'},
    {id: 7, title: 'فاز', value: 'Phase'},
    {id: 8, title: 'آمپر', value: 'Amper'},
    {id: 12, title: 'دوره', value: 'Period'},
    {id: 13, title: 'سال', value: 'Year'},
    {id: 9, title: 'تاریخ قرائت', value: 'CurrentReadingDate',noComma:true},
    {id: 10, title: 'تاریخ قرائت پیشین', value: 'PreviousReadingDate',noComma:true},
    {id: 11, title: 'تاریخ صدور', value: 'BillExportationDate',noComma:true},
    {id: 14, title: 'تعداد روز', value: 'TotalDaysCount'},
    {id: 15, title: 'تعداد روز سرد', value: 'ColdDaysCount'},
    {id: 16, title: 'تعداد روز گرم', value: 'WarmDaysCount'},
    {id: 17, title: 'هزینه خالص', value: 'PeriodAmount'},
    {id: 18, title: 'نوع ولتاژ', value: 'VoltageType'},
    {id: 19, title: 'قیمت متوسط', value: 'AverageConsumption'},
    {id: 20, title: 'بدهی پیشین', value: 'PreviousDebt'},
    {id: 21, title: 'مالیات', value: 'TaxAmount'},
    {id: 22, title: 'عوارض برق', value: 'ElectricityTaxAmount'},
    {id: 23, title: 'هزینه انرژی', value: 'EnergyAmount'},
    {id: 24, title: 'مصرف کم باری', value: 'LowConsumption'},
    {id: 25, title: 'مصرف میان باری', value: 'NormalConsumption'},
    {id: 26, title: 'مصرف پر باری', value: 'PeakConsumption'},
    {id: 27, title: 'آبونمان', value: 'SubscriptionAmount'},
    {id: 28, title: 'هزینه فصل', value: 'SeasonAmount'},
    {id: 29, title: 'مبلغ بیمه', value: 'InsuranceAmount'},
    {id: 30, title: 'مصرف روز جمعه', value: 'FridayConsumption'},
    {id: 31, title: 'سایر هزینه ها', value: 'OtherDebtAmount'},
  ];

  export const waterProperties = [
    {id: 1, title: 'وضعیت', value: 'status'},
    {id: 2, title: 'آدرس', value: 'Address'},
    {id: 3, title: 'کد پستی', value: 'PostalCode',noComma:true},
    {
      id: 4,
      title: 'تاریخ قرائت پیشین',
      value: 'PreviousDate',
      noComma: true,
    },
    {id: 5, title: 'تاریخ قرائت کنونی', value: 'CurrentDate', noComma: true},
    {id: 6, title: 'کنتور پیشین', value: 'PreviousNumber',noComma:true},
    {id: 7, title: 'کنتور کنونی', value: 'CurrentNumber',noComma:true},
    {id: 8, title: 'بهای آب مصرفی', value: 'WaterPrice'},
    {id: 9, title: 'بدهی پیشین', value: 'PreviousDebt'},
  
  ];